module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Cast of Characters")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.375",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAlexand DeKoven Woolf"), _c('br'), _vm._v("\n\t\t\t\t(Alex Ransom)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tFirst born and heir to the First Lordship of the House of DeKoven Woolf, indirect heir to the Chairmanship of the Directorate")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tRichard DeKoven Woolf"), _c('br'), _vm._v("\n\t\t\t\t(Richard Lamb)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAlexand’s younger brother")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tPhillip DeKoven Woolf")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAlexand’s father, First Lord of the House of DeKovep Woolf and member of the Directorate")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tElise Galinin Woolf")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAlexand’s mother, the daughter of Mathis Galinin")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tTheron Rovere")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tLector; Alexand’s and Rich’s tutor")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tFenn Lacroy")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tSportsMaster in the House of DeKoven Woolf and Phoenix agent")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tMathis Daro Galinin")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tFirst Lord of the House of Daro Galinin and Chairman of the Directorate")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tOrin Badir Selasis")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tFirst Lord of the House of Badir Selasis, member of the Directorate, and bitter antagonist to Woolf and Galinin")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tKarlis Selasis")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tFirst born of Lord Orin Selasis")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAdrien Camine Eliseer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tDaughter of Lord Loren Camine Eliseer of Castor, and Alexand’s Promised")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tLectris and Mariet")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAdrien’s Bond servants")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAmik the Thief")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tAlso known as the Lord of Thieves, head of the Brotherhood, a predominantly criminal organization prevalent in the Outside")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tMaster Bruno"), _c('br'), _vm._v("\n\t\t\t\tHawkwood")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tOrin Selasis’s chief henchman, also known as the Master of Shadows")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tDr. Lile Perralt")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tEliseer family physician and a Phoenix agent")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tSister Thea")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tA nun of the Order of Faith, Supra of the Convent of Saint Petra’s of Ellay on Castor")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tMalaki")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\tElder Shepherd in the Eliseer Estate Bond compound")])])])]), _vm._v(" "), _c('div', [_c('h2', {
    staticClass: "chap",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Society of the Phoenix")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "35%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tDr. Andreas Riis")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tFounder of the Phoenix, chairman of its Council, and creator of the matter transmitter")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tDr. Erica Radek")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tCouncil member, head of the Human Sciences Department")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tBen Venturi")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tCouncil member and commander of Security and Intelligence")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tPredis Ussher")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tCouncil member, head of Communications, who claims to be the son of Elor, last Lord of the House of Peladeen")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tEmeric Garris")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tCouncil member, commander of Fleet Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tJohn M’Kim")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tCouncil member, head of Supply and Maintenance")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tManen Dyce")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tCouncil member, head of Computer Systems")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tJan Barret")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tLeftant Commander in Fleet Operations")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tValentin Severin")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tAssistant to Erica Radek")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tJael")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("\n\t\t\t\t\tNew member of the Phoenix, its first Outsider")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15bc505c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/007character.vue
// module id = 69
// module chunks = 0